import { cardClassName } from "@/modules/utils/dashboard/constants";
import { KpiItem } from "@/modules/types/dashboard";
import { useClientTranslations } from "@/lib/translate";

type DashboardKpiSectionProps = {
  items: KpiItem[];
};

export const DashboardKpiSection = ({ items }: DashboardKpiSectionProps) => {
  const { t } = useClientTranslations("dashboard-page");

  return (
    <section className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
      {items.map((item) => (
        <article key={item.labelKey} className={cardClassName}>
          <p className="text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400">
            {t(`dashboard.kpi.${item.labelKey}`)}
          </p>
          <p className="mt-2 text-2xl font-semibold text-slate-900 dark:text-slate-100">
            {item.value}
          </p>
        </article>
      ))}
    </section>
  );
};
